import { footerLinks } from "@/mocks/home";

const hotTags = ["实锤截图", "聊天记录", "证据截图", "爆料截图", "现场原图"];

export default function SiteFooter() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-image-2-line text-lg" />
              </span>
              <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">
                黑料图片
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              聚焦黑料图片，实锤截图与聊天记录一手直达。高清原图、证据截图持续更新，帮你快速锁定关键信息。
            </p>
            <a
              href="#download"
              className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-download-2-line text-base" />
              下载客户端
            </a>
          </div>

          <div className="md:col-span-3 md:col-start-7">
            <h4 className="font-heading text-sm font-bold uppercase tracking-widest text-foreground-800">
              站内导航
            </h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {footerLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading text-sm font-bold uppercase tracking-widest text-foreground-800">
              热门标签
            </h4>
            <div className="mt-4 flex flex-wrap gap-2">
              {hotTags.map((tag) => (
                <a
                  key={tag}
                  href="#overview"
                  className="rounded-full border border-background-300 px-3 py-1 text-xs text-foreground-600 transition-colors hover:border-primary-400 hover:text-primary-600"
                >
                  {tag}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-200 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs leading-relaxed text-foreground-500">
            本站图文来自公开讨论整理，仅供信息对照阅读，不构成任何事实认定。
          </p>
          <p className="text-xs text-foreground-500">
            © 2026 黑料图片 · 内容持续更新
          </p>
        </div>
      </div>
    </footer>
  );
}